module.exports = ".search-result {\n  border: 1px solid gray;\n  width: 100%;\n  padding: 5px;\n  background-color: white;\n  cursor: pointer; }\n\n.search-result:hover {\n  color: #eee;\n  background-color: #607D8B; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/promos/shared/promo-form/promo-form.component.scss
// module id = ./src/app/promos/shared/promo-form/promo-form.component.scss
// module chunks = main